const TECHNIQUE_PARAMETER_CONFIG = {
  simple: {
    fields: [],
    message: 'Simple randomization only needs the seed; no block or cluster inputs are used.'
  },
  blocked: {
    fields: ['blockSize'],
    message: 'Fixed block randomization needs a block size divisible by the number of arms, and N must be divisible by block size.'
  },
  'random-block': {
    fields: ['blockSizes'],
    message: 'Random block randomization needs a comma-separated list of allowed block sizes.'
  },
  clustered: {
    fields: ['clusterSizes'],
    message: 'Cluster randomization needs comma-separated cluster sizes; named clusters can use Name:size.'
  },
  'stratified-blocked': {
    fields: ['strataSizes', 'blockSize'],
    message: 'Stratified fixed block randomization needs strata as Name:size and a fixed block size that divides every stratum.'
  },
  'stratified-random-block': {
    fields: ['strataSizes', 'blockSizes'],
    message: 'Stratified random block randomization needs strata as Name:size and allowed block sizes for within-stratum blocks.'
  },
  'cluster-stratum': {
    fields: ['clusterStrata', 'blockSizes'],
    message: 'Cluster as stratum randomizes participants inside each cluster/center; clusters are balance strata, not single-treatment units.'
  },
  'cluster-stratified': {
    fields: ['clusterStrataSizes'],
    message: 'Cluster-stratified randomization assigns whole clusters within each stratum; use Stratum|Cluster:size.'
  }
};

function getTechniqueParameterConfig(technique) {
  const config = TECHNIQUE_PARAMETER_CONFIG[technique];

  if (!config) {
    throw new Error(`Unknown randomization technique: ${technique}`);
  }

  return config;
}

function normalizeTechniqueParams(rawParams) {
  const config = getTechniqueParameterConfig(rawParams.technique);
  const normalized = {
    studyName: rawParams.studyName,
    n: rawParams.n,
    arms: rawParams.arms,
    armLabels: rawParams.armLabels,
    seed: rawParams.seed,
    technique: rawParams.technique
  };

  config.fields.forEach((field) => {
    normalized[field] = rawParams[field];
  });

  return normalized;
}

module.exports = {
  TECHNIQUE_PARAMETER_CONFIG,
  getTechniqueParameterConfig,
  normalizeTechniqueParams
};
